import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Button from "material-ui/Button";
import ArrowLeft from "../../../Icons/ArrowLeft";
import FilterTabs from "../../../common/FilterTabs";
import { SalesforceSettingDirectory } from "../../../../constants/ComponentTypes";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  returnBtn: {
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
  },

  heading: {
    width: "100%",
    marginTop: "14px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "30px",
  },

  body: {
    width: "100%",
    margin: "40px 0px 90px 0px",
  },
});

/**
 * 各の連携項目のSalesforceの連携の概要ページラッパーコンポーネント
 */
class SalesforceIntegrateOverview extends React.Component {
  handleTabClicked = (value) => {
    let directory = Object.values(SalesforceSettingDirectory).find(
      (item) => item.value === value
    );

    this.props.goTo(directory.setting_path);
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div
          className={classes.progressbar}
          style={{ justifyContent: "flex-start" }}
        >
          <Button
            className={classes.returnBtn}
            onClick={() => this.props.goTo(`/setting/integrations/salesforce`)}
          >
            <ArrowLeft
              color="#71737B"
              width={14}
              height={14}
              style={{ marginRight: "6px" }}
            />
            <span>戻る</span>
          </Button>
        </div>
        <div className={classes.heading}>
          <Typography variant="title" className={classes.title}>
            Salesforce連携設定
          </Typography>

          <FilterTabs
            value={this.props.tabValue}
            handleTabClicked={this.handleTabClicked}
            tabValues={Object.values(SalesforceSettingDirectory)}
          />
        </div>
        <div className={classes.body}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

SalesforceIntegrateOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  tabValue: PropTypes.number.isRequired,
  goTo: PropTypes.func,
  children: PropTypes.node,
};

// @see 空を返してますが、エラーが発生するのでmapStateToPropsにconnectする必要があります。
const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goTo(url, state) {
      dispatch(push(url, state));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceIntegrateOverview));



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceIntegrateOverview.jsx